import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { ELEMENTOS } from '../../data/retiro';
export function Elementos() {
  return <section id="elementos" className="w-full px-5 py-24 sm:px-8 sm:py-32" data-id="element-108" data-mp="z1sf4qqkt3o1">
      <div className="mx-auto max-w-7xl" data-id="element-109" data-mp="z3vcxwxz013b">
        <SectionHeading eyebrow="Experiencias para sentir y fluir" title="Desenredar con la tierra, el agua, el fuego, el aire y el sonido" subtitle="Tres ejes que sostienen la experiencia, diseñados para que lo que vivas no se quede allá, sino que te acompañe al volver." data-id="element-110" data-mp="1415a5yrlph1p" />

        <div className="mt-20 flex flex-col gap-20 md:gap-28" data-id="element-111" data-mp="1htbe8mhhbxks">
          {ELEMENTOS.map((el, i) => {
          const reverse = i % 2 === 1;
          return <div key={el.nombre} className="grid items-center gap-10 md:grid-cols-2 md:gap-16" data-id="element-112" data-mp="1rqpvgob88qe5" data-mpi={i}>
                <Reveal className={reverse ? 'md:order-2' : ''} data-id="element-113" data-mp="1vskt9ity8ln6">
                  <div className="relative overflow-hidden rounded-[2rem]" data-id="element-114" data-mp="16z5zm1wojo0r">
                    <img src={el.imagen} alt={`Elemento: ${el.nombre} — ${el.titulo}`} className="aspect-[4/5] w-full object-cover" data-id="element-115" data-mp="11zjk1ltdpvos" />
                    <div className="absolute inset-x-0 bottom-0 h-1/3" style={{
                  background: 'linear-gradient(180deg, transparent 0%, rgba(42,36,32,0.5) 100%)'
                }} data-id="element-116" data-mp="s1vlslwke61v" />
                    <span className="absolute left-6 top-6 text-5xl" data-id="element-117" data-mp="1fyt26r15azve">
                      {el.emoji}
                    </span>
                  </div>
                </Reveal>

                <Reveal delay={0.1} className={reverse ? 'md:order-1' : ''} data-id="element-118" data-mp="28flwibi6vskh">
                  <span className="text-xs font-medium uppercase tracking-[0.28em]" style={{
                color: el.acento
              }} data-id="element-119" data-mp="28hotxglo8nz8">
                    {el.numero}
                  </span>
                  <h3 className="mt-3 font-heading text-2xl font-light sm:text-3xl" style={{
                color: 'var(--ink)'
              }} data-id="element-120" data-mp="6pwqspcfz4g8">
                    {el.nombre}
                    <span className="block text-lg" style={{
                  color: 'rgba(42,36,32,0.55)'
                }} data-id="element-121" data-mp="3f6hqtgn3in77">
                      {el.titulo}
                    </span>
                  </h3>

                  <ul className="mt-6 space-y-4" data-id="element-122" data-mp="3a757v6zci09w">
                    {el.puntos.map(p => <li key={p.titulo} data-id="element-123" data-mp="13gp8tsixr6kn">
                        <span className="font-medium" style={{
                    color: 'var(--ink)'
                  }} data-id="element-124" data-mp="13hqm83nfc55j">
                          {p.titulo}.{' '}
                        </span>
                        <span style={{
                    color: 'rgba(42,36,32,0.72)'
                  }} data-id="element-125" data-mp="2nzsq5xpbqdsv">
                          {p.texto}
                        </span>
                      </li>)}
                  </ul>

                  <blockquote className="mt-7 border-l-2 pl-5 font-heading text-base font-light italic leading-relaxed" style={{
                borderColor: el.acento,
                color: 'var(--ink)'
              }} data-id="element-126" data-mp="3bn0xsma85yy2">
                    {el.cita}
                  </blockquote>
                </Reveal>
              </div>;
        })}
        </div>
      </div>
    </section>;
}